export default "__VITE_ASSET__B6anAt$b__"